// extracted by mini-css-extract-plugin
export var cardTitle = "_hy-1";
export var commentBubble = "_hy-e";
export var commentForm = "_hy-a";
export var commentInput = "_hy-b";
export var commentLabel = "_hy-d";
export var commentPrompt = "_hy-9";
export var csatCard = "_hy-0";
export var feedbackSection = "_hy-7";
export var starDisabled = "_hy-6";
export var starEmpty = "_hy-5";
export var starFilled = "_hy-4";
export var starWrapper = "_hy-3";
export var starsContainer = "_hy-2";
export var submittedComment = "_hy-c";
export var thankYouText = "_hy-8";